module.exports = __webpack_public_path__ + "static/media/maelle.74c72dd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/maelle.jpg
// module id = 1824
// module chunks = 0